// extracted by mini-css-extract-plugin
export default {"wrapperLoader":"Loader_wrapperLoader__Jb8bb","cashOutInfo":"Loader_cashOutInfo__axFjR"};